import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import BoardNavbar from "@/views/product/testing/Navbar.vue";
import Banner from "@/components/Banner.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'KAT',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "진단검사",
      subtitle: "진단검사",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createVNode(BoardNavbar),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "width_wrap" }, [
      _createElementVNode("div", { class: "body_content" }, [
        _createElementVNode("h1", { class: "sub_subject" }, "KAT지식통각검사"),
        _createElementVNode("div", { class: "sub1" }, [
          _createElementVNode("p", null, " KATKnowledge Apperception Test (지식통각검사)'는 본 연구소에 전화 또는 Email을 통해 직접 문의해 주시기 바랍니다. ")
        ])
      ])
    ], -1))
  ]))
}
}

})